import { BrowserRouter, Routes, Route } from "react-router";
import { GuestGuard } from "./GuestGuard";
import { AppLayout } from "./layouts/AppLayout";
import { SignupLayout } from "./layouts/SignupLayout";
import { LandingPage } from "./pages/LandingPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsPage } from "./pages/TermsPage";
import { LoginPage } from "./pages/LoginPage";
import { SignupEmailPage } from "./pages/SignupEmailPage";
import { SignupPasswordPage } from "./pages/SignupPasswordPage";
import { SignupNamePage } from "./pages/SignupNamePage";
import { DashboardPage } from "./pages/DashboardPage";
import { SitesPage } from "./pages/SitesPage";
import { NewSitePage } from "./pages/NewSitePage";
import { TeamPage } from "./pages/TeamPage";
import { RotaPage } from "./pages/RotaPage";
import { MyPage } from "./pages/MyPage";
import { SettingsPage } from "./pages/SettingsPage";
import { VisitsPage } from "./pages/VisitsPage";
import { BillingPage } from "./pages/BillingPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { InviteAcceptPage } from "./pages/InviteAcceptPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { DevEmailsPage } from "./pages/DevEmailsPage";
import { AdminHomePage } from "./pages/AdminHomePage";
import { AdminEmailsPage } from "./pages/AdminEmailsPage";
import { AdminEmailsTemplatesPage } from "./pages/AdminEmailsTemplatesPage";
import { AdminOrgsPage } from "./pages/AdminOrgsPage";
import { AdminOrgDetailPage } from "./pages/AdminOrgDetailPage";
import { AdminStripeEventsPage } from "./pages/AdminStripeEventsPage";
import { AdminBillingAuditPage } from "./pages/AdminBillingAuditPage";
import { AdminFunnelPage } from "./pages/AdminFunnelPage";
import { DevToolbar } from "@/components/app/DevToolbar";
import { RouteHit } from "@/analytics/RouteHit";

export function App() {
  return (
    <BrowserRouter>
      <RouteHit />
      {import.meta.env.DEV && <DevToolbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />

        <Route
          path="/login"
          element={
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          }
        />

        <Route
          path="/forgot-password"
          element={
            <GuestGuard>
              <ForgotPasswordPage />
            </GuestGuard>
          }
        />

        <Route
          path="/reset-password/:token"
          element={
            <GuestGuard>
              <ResetPasswordPage />
            </GuestGuard>
          }
        />

        <Route
          element={
            <GuestGuard>
              <SignupLayout />
            </GuestGuard>
          }
        >
          <Route path="/signup" element={<SignupEmailPage />} />
          <Route path="/signup/password" element={<SignupPasswordPage />} />
          <Route path="/signup/name" element={<SignupNamePage />} />
        </Route>

        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/invite/:token" element={<InviteAcceptPage />} />

        <Route path="/dev/emails" element={<DevEmailsPage />} />

        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/sites" element={<SitesPage />} />
          <Route path="/sites/new" element={<NewSitePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/rota" element={<RotaPage />} />
          <Route path="/my" element={<MyPage />} />
          <Route path="/visits" element={<VisitsPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/admin" element={<AdminHomePage />} />
          <Route path="/admin/emails" element={<AdminEmailsPage />} />
          <Route path="/admin/emails/templates" element={<AdminEmailsTemplatesPage />} />
          <Route path="/admin/orgs" element={<AdminOrgsPage />} />
          <Route path="/admin/orgs/:id" element={<AdminOrgDetailPage />} />
          <Route path="/admin/stripe-events" element={<AdminStripeEventsPage />} />
          <Route path="/admin/billing-audit" element={<AdminBillingAuditPage />} />
          <Route path="/admin/funnel" element={<AdminFunnelPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
